/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Applogo } from "../../../Routes/ImagePath";
import { Controller, useForm } from "react-hook-form";
import * as Yup from "yup";
import { yupResolver } from "@hookform/resolvers/yup";
import { useFirstLoginPasswordMutation } from "../../../services/auth.service";
import alertify from "alertifyjs";

const validationSchema = Yup.object().shape({
  temp_password: Yup.string().required("Temporary password is required"),
  new_password: Yup.string()
    .min(6, "Password must be at least 6 characters")
    .max(20, "Password must be at most 20 characters")
    .required("New password is required"),
  confirm_password: Yup.string()
    .oneOf([Yup.ref("new_password"), null], "Passwords must match")
    .required("Please confirm your password"),
});

const ChangePasswordFirstLogin = () => {
  const navigate = useNavigate();
  const [showTempPassword, setShowTempPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [changePassword, { isLoading }] = useFirstLoginPasswordMutation();

  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(validationSchema),
  });

  useEffect(() => {
    // Check if user should be on this page
    const mustChangePassword = localStorage.getItem("must_change_password");
    const tempToken = localStorage.getItem("temp_token");

    if (!mustChangePassword || !tempToken) {
      navigate("/");
    }
  }, []);

  const onSubmit = async (data) => {
    try {
      const tempToken = localStorage.getItem("temp_token");

      const response = await changePassword({
        temp_password: data.temp_password,
        new_password: data.new_password,
        confirm_password: data.confirm_password,
      }).unwrap();

      if (response.success) {
        // Clear temporary storage
        localStorage.removeItem("temp_token");
        localStorage.removeItem("must_change_password");

        alertify.success(response.message);
        navigate("/");
      } else {
        alertify.error(response.message);
      }
    } catch (error) {
      alertify.error(error?.data?.message || "Failed to change password");
    }
  };

  return (
    <div>
      <div className="account-page">
        <div className="main-wrapper">
          <div className="account-content">
            <div className="container">
              {/* Account Logo */}
              <div className="account-logo">
                <Link to="/">
                  <img src={Applogo} alt="Company Logo" />
                </Link>
              </div>
              {/* /Account Logo */}
              <div className="account-box">
                <div className="account-wrapper">
                  <h3 className="account-title">Change Password</h3>
                  <p className="account-subtitle">
                    Please change your temporary password to continue
                  </p>

                  <form onSubmit={handleSubmit(onSubmit)}>
                    {/* Temporary Password */}
                    <div className="input-block mb-4">
                      <label className="col-form-label">Temporary Password</label>
                      <div style={{ position: "relative" }}>
                        <Controller
                          name="temp_password"
                          control={control}
                          render={({ field }) => (
                            <input
                              className={`form-control ${
                                errors?.temp_password ? "error-input" : ""
                              }`}
                              type={showTempPassword ? "text" : "password"}
                              placeholder="Enter temporary password from email"
                              onChange={field.onChange}
                              value={field.value || ""}
                            />
                          )}
                        />
                        <span
                          style={{
                            position: "absolute",
                            right: "5%",
                            top: "30%",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowTempPassword(!showTempPassword)}
                          className={`fa-solid ${
                            showTempPassword ? "fa-eye" : "fa-eye-slash"
                          }`}
                        />
                      </div>
                      <span className="text-danger">
                        {errors.temp_password?.message}
                      </span>
                    </div>

                    {/* New Password */}
                    <div className="input-block mb-4">
                      <label className="col-form-label">New Password</label>
                      <div style={{ position: "relative" }}>
                        <Controller
                          name="new_password"
                          control={control}
                          render={({ field }) => (
                            <input
                              className={`form-control ${
                                errors?.new_password ? "error-input" : ""
                              }`}
                              type={showNewPassword ? "text" : "password"}
                              placeholder="Enter new password"
                              onChange={field.onChange}
                              value={field.value || ""}
                            />
                          )}
                        />
                        <span
                          style={{
                            position: "absolute",
                            right: "5%",
                            top: "30%",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          className={`fa-solid ${
                            showNewPassword ? "fa-eye" : "fa-eye-slash"
                          }`}
                        />
                      </div>
                      <span className="text-danger">
                        {errors.new_password?.message}
                      </span>
                    </div>

                    {/* Confirm Password */}
                    <div className="input-block mb-4">
                      <label className="col-form-label">Confirm New Password</label>
                      <div style={{ position: "relative" }}>
                        <Controller
                          name="confirm_password"
                          control={control}
                          render={({ field }) => (
                            <input
                              className={`form-control ${
                                errors?.confirm_password ? "error-input" : ""
                              }`}
                              type={showConfirmPassword ? "text" : "password"}
                              placeholder="Confirm new password"
                              onChange={field.onChange}
                              value={field.value || ""}
                            />
                          )}
                        />
                        <span
                          style={{
                            position: "absolute",
                            right: "5%",
                            top: "30%",
                            cursor: "pointer",
                          }}
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          className={`fa-solid ${
                            showConfirmPassword ? "fa-eye" : "fa-eye-slash"
                          }`}
                        />
                      </div>
                      <span className="text-danger">
                        {errors.confirm_password?.message}
                      </span>
                    </div>

                    <div className="input-block text-center">
                      <button
                        className="btn btn-primary account-btn"
                        type="submit"
                        disabled={isLoading}
                      >
                        {isLoading ? "Changing Password..." : "Change Password"}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChangePasswordFirstLogin;
